import { useState } from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export function ResetStartButton({ job, onDone }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/jobs/${job.id}/reset-start`);
      toast.success("Intervento riportato a 'da iniziare'");
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="rounded-full border-amber-300 text-amber-700" data-testid="job-detail-reset-start-button">
        <RotateCcw className="h-4 w-4" /> Azzera avvio</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="reset-start-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Azzerare l'avvio dell'intervento?</AlertDialogTitle>
            <AlertDialogDescription>
              L'intervento torna "confermato / da iniziare" come se non fosse mai stato avviato. Foto e dati del cliente restano; il tecnico riceve una notifica.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="reset-start-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); run(); }} disabled={busy} data-testid="reset-start-confirm">Sì, azzera</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
